// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Star = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Star = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Star = _exports.Star = function Star(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#prefix__a)"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M9.966.347c.347 0 .664.197.815.51l2.59 5.337 5.786.854a.9.9 0 0 1 .73.615.91.91 0 0 1-.224.926l-4.195 4.162.99 5.877a.908.908 0 0 1-1.322.952l-5.174-2.765-5.166 2.761a.9.9 0 0 1-.956-.064.92.92 0 0 1-.366-.887l.99-5.878L.267 8.59a.9.9 0 0 1-.223-.926.91.91 0 0 1 .729-.615l5.785-.854L9.15.857a.91.91 0 0 1 .817-.51m0 2.984L7.983 7.418a.92.92 0 0 1-.684.502l-4.467.658 3.244 3.214a.91.91 0 0 1 .257.793l-.767 4.521 3.973-2.123a.9.9 0 0 1 .853 0l3.973 2.123-.763-4.517a.9.9 0 0 1 .257-.793l3.244-3.215-4.468-.66a.91.91 0 0 1-.683-.503z"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "prefix__a"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M0 0h20v20H0z"
    }))));
  };
});
